(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskTemplateAddEdit',
	};

	var form_id = 'tasktemplateaddedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var classification      = $('#' + form_id + 'classification').val();
		var task_template_id    = $('#' + form_id + 'id').val();
		var $due_based_on_field = null;

		_hideEntityFields();

		Adzuki.TaskManager.initTaskTagFields(form_id);

		// changing the due date based on for a classification
		$('#' + form_id + 'due_based_on').change(function onDueDateBasedChange(e)
		{
			Adzuki.TaskManager.dueBasedOnFieldChange(form_id);
		});

		if (classification) {
			$('.due-based-on-field').removeClass('hidden');

			if (classification === 'reservation') {
				$('.travel-type-field').removeClass('hidden');
			}

			if (task_template_id) {
				// editing an existing task template
				$due_based_on_field = $('#' + form_id + 'due_based_on');

				// if we are dealing with a task template that does not
				// have a default due date, don't show the due on days fields
				if ($due_based_on_field.val() === 'no_due_date') {
					$due_based_on_field.trigger('change');
				} else {
					$('.due-on-field').removeClass('hidden');
				}

				$('#' + form_id + 'due_based_days').trigger('change');
			} else {
				// populate the due date based on only when creating a new task template
				_populateDueDateBasedOn(classification);
			}
		}
	};

	function _hideEntityFields()
	{
		$('.due-based-on-field').addClass('hidden');
		$('.due-on-field').addClass('hidden');
		$('.travel-type-field').addClass('hidden');
	}

	function _populateDueDateBasedOn(entity)
	{
		var $due_based_on_field = $('#' + form_id + 'due_based_on');
		var sorted_data         = [];
		var entity_data         = [];

		$due_based_on_field.empty();
		$due_based_on_field.append(
			$('<option>').text('Select a Due Date Based On').attr('value', '')
		);

		Adzuki.Ajax.get('/Tasks/getClassificationDates/' + entity)
		.then(function populateEntityDates(response)
		{
			sorted_data = Adzuki.Sort.alphabeticValue(response);

			$.each(sorted_data, function appendOption(key, val) {
				entity_data.push($('<option>').text(val.value).attr('value', val.key));
			});

			// add no default due date option
			entity_data.push($('<option>')
						.text('No Default Due Date')
						.attr('value', 'no_due_date'));

			$due_based_on_field.append(entity_data);

			$('#' + form_id + 'due_based_on').trigger('change');
		});
	}
}(jQuery, window.Adzuki || {}));
